// src/services/adminWholesaleRequests.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminWholesaleRequests = () => {
  return adminApiRequest("/admin/wholesale-requests");
};

export const getAdminWholesaleRequestById = (id) => {
  return adminApiRequest(`/admin/wholesale-requests/${id}`);
};

export const updateAdminWholesaleRequestStatus = (id, status) => {
  return adminApiRequest(`/admin/wholesale-requests/${id}/status`, {
    method: "PUT",
    body: JSON.stringify({ status }),
  });
};

export const deleteAdminWholesaleRequest = (id) => {
  return adminApiRequest(`/admin/wholesale-requests/${id}`, {
    method: "DELETE",
  });
};